import * as Yup from "yup";
import moment from "moment";

export const periodicIsoInitialValues = {
  isoID: "",
  currency: "USD",
  reportStartDate: "",
  reportEndDate: "",
};

// Calcular fechas límite usando moment
const today = moment();
const ninetyDaysAgo = moment().subtract(90, "days");

const todayString = today.format("YYYY-MM-DD");
const ninetyDaysAgoString = ninetyDaysAgo.format("YYYY-MM-DD");

// Función helper para convertir YYYYMMDD a moment
const parseDate = (value) => {
  if (!value) return null;

  if (value.match(/^\d{8}$/)) {
    // Formato: YYYYMMDD -> moment
    return moment(value, "YYYYMMDD");
  }

  // Intentar parsear como fecha estándar
  return moment(value);
};

// Función helper para validar rango de fechas
const validateDateRange = (value, fieldName) => {
  const date = parseDate(value);
  if (!date || !date.isValid()) return false;

  const today = moment();
  const ninetyDaysAgo = moment().subtract(90, "days");

  const isValid = date.isBetween(ninetyDaysAgo, today, "day", "[]");

  console.log(`🔍 ${fieldName} Validation:`, {
    originalValue: value,
    parsedDate: date.format("YYYY-MM-DD"),
    ninetyDaysAgo: ninetyDaysAgo.format("YYYY-MM-DD"),
    today: today.format("YYYY-MM-DD"),
    isValid,
  });

  return isValid;
};

export const periodicIsoValidationSchema = Yup.object().shape({
  isoID: Yup.string().required("ISO ID is required"),
  currency: Yup.string().required("Currency is required"),
  reportStartDate: Yup.string()
    .required("Report Start Date is required")
    .test(
      "date-range",
      `Start date must be between ${ninetyDaysAgoString} and ${todayString}`,
      function (value) {
        return validateDateRange(value, "Start Date");
      }
    ),
  reportEndDate: Yup.string()
    .required("Report End Date is required")
    .test(
      "date-range",
      `End date must be between ${ninetyDaysAgoString} and ${todayString}`,
      function (value) {
        return validateDateRange(value, "End Date");
      }
    )
    .test(
      "end-after-start",
      "End date must be after or equal to start date",
      function (value) {
        const { reportStartDate } = this.parent;
        if (!value || !reportStartDate) return true;

        const startDate = parseDate(reportStartDate);
        const endDate = parseDate(value);

        if (
          !startDate ||
          !endDate ||
          !startDate.isValid() ||
          !endDate.isValid()
        ) {
          return true; // Dejar que otras validaciones manejen los errores
        }

        const isValid = endDate.isSameOrAfter(startDate, "day");

        console.log("🔍 Date Range Validation:", {
          startDate: startDate.format("YYYY-MM-DD"),
          endDate: endDate.format("YYYY-MM-DD"),
          isValid,
        });

        return isValid;
      }
    ),
});
